// Auto-generated - do not edit manually
  export const APP_VERSION = '20260123.482';
